import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

export const handleMessageConfirm = (pushNotification: IPushNotification): void => {
  if (pushNotification.group) {
    Entities.pushNotifications.clearNotificationsByGroupId(pushNotification.group);
  }
};
